import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Button } from './ui/Button';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <div ref={ref} className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-160">
      {/* Background Image with Parallax */}
      <motion.div style={{
      y,
      opacity
    }} className="absolute inset-0 z-0" data-id="element-161">
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60 z-10" data-id="element-162" />
        <img src="https://images.unsplash.com/photo-1544735716-392fe2489ffa?q=80&w=2071&auto=format&fit=crop" alt="Himalayan Mountains" className="w-full h-full object-cover" data-id="element-163" />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 text-center px-4 max-w-5xl mx-auto" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-165">
          <h2 className="text-lg md:text-xl font-medium text-[#06B6D4] mb-4 tracking-widest uppercase" data-id="element-166">
            Discover the Roof of the World
          </h2>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight" data-id="element-167">
            Ascend Beyond <br data-id="element-168" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0066FF] via-[#8B5CF6] to-[#06B6D4]" data-id="element-169">
              Expectations
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-170">
            Experience the majesty of the Himalayas with expert guides. From
            Everest Base Camp to hidden valleys, your adventure awaits.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-171">
            <Button variant="primary" size="lg" className="min-w-[180px]" data-id="element-172">
              Start Your Journey
            </Button>
            <Button variant="outline" size="lg" className="min-w-[180px]" data-id="element-173">
              Explore More
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      delay: 1,
      duration: 2,
      repeat: Infinity
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 text-white cursor-pointer" data-id="element-174">
        <ChevronDown size={32} data-id="element-175" />
      </motion.div>
    </div>;
}